
import Vue from 'vue'
import { VFooter } from 'vuetify/lib'
import { formatDisplayDateTime } from '@/util/formatters'

export default Vue.extend({
  name: 'JcdcFooter',
  components: {
    VFooter,
  },
  props: {
    infoDate: { type: [String, Date, Number, Object], default: undefined },
  },
  data: () => ({}),
  methods: {
    formatDisplayDateTime,
  },
})
